import { DASHBOARD_PERIODS } from '../../constants/app'

export default function DashboardPeriodFilter({ onChange, value }) {
  return (
    <div className="flex w-full flex-col gap-1 rounded-xl border border-[#D6CDBF] bg-white p-1 shadow-[0_10px_24px_rgba(26,26,26,0.04)] sm:w-auto sm:flex-row sm:rounded-full">
      {DASHBOARD_PERIODS.map((period, index) => (
        <button
          className={`flex h-9 min-w-0 items-center justify-center rounded-lg px-3 text-xs font-bold whitespace-nowrap transition sm:min-w-[112px] ${
            value === period.value
              ? 'bg-[#1A1A1A] text-white shadow-sm'
              : 'text-[#5A5147] hover:bg-[#F8E1E7]'
          } ${index === 0 ? 'sm:rounded-l-full' : ''} ${
            index === DASHBOARD_PERIODS.length - 1 ? 'sm:rounded-r-full' : ''
          }`}
          type="button"
          key={period.value}
          onClick={() => onChange(period.value)}
        >
          {period.label}
        </button>
      ))}
    </div>
  )
}
